module.exports = __webpack_public_path__ + "img/complaintFollowUps.23ef1486.svg";